@import '../../global/style/all-tenants/custom-properties/components-properties/static-teaser';

:host {
  display: block;
  width: var(--cms-container-width);
  margin-bottom: var(--cms-components-mb);
  @include cms-base-font-100;
}

cms-headline {
  --cms-spacing-bottom: var(--cms-spacing-100);
}

.target-icon {
  display: flex;
}

.teaser-href:hover {
  cms-link {
    --cms-link-decoration: underline;
  }
}

.teaser-content {
  @include cms-default-grid-container;
}

.teaser-content-inner {
  @include teaser-content-inner;
}

.badge-wrapper {
  @include cms-static-teaser-badge;
}

.scratch svg path {
  @include cms-static-teaser-scratch-svg-path;
}

.teaser-bottom {
  @include cms-static-teaser-bottom;
}

.teaser-bottom svg path {
  @include cms-static-teaser-bottom-svg-path;
}

.all-topics-wrapper {
  padding-top: var(--cms-spacing-050);
  text-align: center;
  width: 100%;
  margin: auto;
}

.container-wrapper-inner {
  @include container-wrapper-inner;
}

@include media-width($breakpoint-sm) {
  cms-headline {
    --cms-spacing-bottom: var(--cms-spacing-150);
  }

  .teaser-content-inner:nth-child(1):nth-last-child(1) {
    grid-area: auto / 5 / auto / span 4;
  }

  .teaser-content-inner:nth-child(1):nth-last-child(2) {
    grid-area: auto / 3 / auto / span 4;
  }
}